export const emptyLandingPageTemplate = () => ({
    page: {
        body: {
            container: {style: {'background-color': '#FFFFFF'}},
            content: {
                computedStyle: {
                    linkColor: '#151a1d',
                    messageBackgroundColor: 'transparent',
                    messageWidth: '600px',
                },
                style: {
                    color: '#000000',
                    'font-family': 'Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif',
                },
            },
            type: 'mailup-bee-page-properties',
            webFonts: [
                {
                    fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
                    name: 'Open Sans',
                    url: 'https://fonts.googleapis.com/css?family=Open+Sans',
                },
                {
                    fontFamily: "'Lato', Tahoma, Verdana, Segoe, sans-serif",
                    name: 'Lato',
                    url: 'https://fonts.googleapis.com/css2?family=Lato:wght@100;400;700;900&display=swap',
                },
            ],
        },
        description: '',
        rows: [
            {
                columns: [
                    {
                        'grid-columns': 12,
                        modules: [
                            {
                                descriptor: {
                                    computedStyle: {
                                        align: 'center',
                                        hideContentOnMobile: false,
                                    },
                                    divider: {
                                        style: {
                                            'border-top': '30px solid transparent',
                                            height: '64px',
                                            width: '100%',
                                        },
                                    },
                                    style: {
                                        'padding-bottom': '0px',
                                        'padding-left': '0px',
                                        'padding-right': '0px',
                                        'padding-top': '0px',
                                    },
                                },
                                locked: false,
                                type: 'mailup-bee-newsletter-modules-divider',
                                uuid: '34787d3e-b590-4c4e-992a-f62014f635ac',
                            },
                            {
                                descriptor: {
                                    computedStyle: {height: 42, width: 52},
                                    heading: {
                                        style: {
                                            color: '#211712',
                                            direction: 'ltr',
                                            'font-family':
                                                "'Lato', Tahoma, Verdana, Segoe, sans-serif",
                                            'font-size': '17px',
                                            'font-weight': '700',
                                            'letter-spacing': '0px',
                                            'line-height': '120%',
                                            'link-color': '#E01253',
                                            'text-align': 'left',
                                        },
                                        text: '<span class="tinyMce-placeholder">This is a (sort of) blank page</span>',
                                        title: 'h1',
                                    },
                                    style: {
                                        'padding-bottom': '0px',
                                        'padding-left': '0px',
                                        'padding-right': '0px',
                                        'padding-top': '0px',
                                        'text-align': 'center',
                                        width: '100%',
                                    },
                                },
                                locked: false,
                                type: 'mailup-bee-newsletter-modules-heading',
                                uuid: 'd50dba0b-46cd-4053-b787-765a4f15d9f3',
                            },
                            {
                                descriptor: {
                                    computedStyle: {height: 42, width: 52},
                                    heading: {
                                        style: {
                                            color: '#4d4540',
                                            direction: 'ltr',
                                            'font-family':
                                                "'Lato', Tahoma, Verdana, Segoe, sans-serif",
                                            'font-size': '13px',
                                            'font-weight': '400',
                                            'letter-spacing': '0px',
                                            'line-height': '120%',
                                            'link-color': '#E01253',
                                            'text-align': 'left',
                                        },
                                        text: 'Delete, replace, or modify this placeholder content to personalize your landing page. Hover over any section to get started, or seamlessly integrate a Nutshell Form or Scheduler meeting directly into your page content.',
                                        title: 'h1',
                                    },
                                    style: {
                                        'padding-bottom': '0px',
                                        'padding-left': '0px',
                                        'padding-right': '0px',
                                        'padding-top': '12px',
                                        'text-align': 'center',
                                        width: '100%',
                                    },
                                },
                                locked: false,
                                type: 'mailup-bee-newsletter-modules-heading',
                                uuid: 'aeb2e45e-081b-4393-8c78-b6fa135cd453',
                            },
                            {
                                descriptor: {
                                    computedStyle: {height: 42, width: 52},
                                    heading: {
                                        style: {
                                            color: '#4d4540',
                                            direction: 'ltr',
                                            'font-family':
                                                "'Lato', Tahoma, Verdana, Segoe, sans-serif",
                                            'font-size': '13px',
                                            'font-weight': '400',
                                            'letter-spacing': '0px',
                                            'line-height': '120%',
                                            'link-color': '#3b9ed7',
                                            'text-align': 'left',
                                        },
                                        text: '<span class="tinyMce-placeholder">Need more guidance? Check out our <a href="https://support.nutshell.com/en/articles/8790094-landing-pages-create-effective-landing-pages" target="_blank" style="text-decoration: none;" rel="noopener">guide to getting started</a> or explore these <a href="https://www.nutshell.com/blog/high-conversion-landing-pages" target="_blank" style="text-decoration: none;" rel="noopener">best practices for crafting effective landing pages</a>.</span>',
                                        title: 'h1',
                                    },
                                    style: {
                                        'padding-bottom': '0px',
                                        'padding-left': '0px',
                                        'padding-right': '0px',
                                        'padding-top': '12px',
                                        'text-align': 'center',
                                        width: '100%',
                                    },
                                },
                                locked: false,
                                type: 'mailup-bee-newsletter-modules-heading',
                                uuid: '7bc7a084-20a5-4869-9410-574a6aef2b7c',
                            },
                            {
                                descriptor: {
                                    computedStyle: {hideContentOnMobile: false},
                                    spacer: {style: {height: '16px'}},
                                },
                                locked: false,
                                type: 'mailup-bee-newsletter-modules-spacer',
                                uuid: '7e9afa17-4e4b-4ffc-ae75-5aaa9d39c80a',
                            },
                            {
                                descriptor: {
                                    button: {
                                        label: '<div class="txtTinyMce-wrapper" style="" data-mce-style=""><p dir="ltr" style="word-break: break-word;" data-mce-style="word-break: break-word;">Learn more</p></div>',
                                        style: {
                                            'background-color': '#3b9ed7',
                                            'border-bottom': '0px solid transparent',
                                            'border-left': '0px solid transparent',
                                            'border-radius': '4px',
                                            'border-right': '0px solid transparent',
                                            'border-top': '0px solid transparent',
                                            color: '#ffffff',
                                            direction: 'ltr',
                                            'font-family': 'inherit',
                                            'font-size': '13px',
                                            'font-weight': '400',
                                            'line-height': '200%',
                                            'max-width': '100%',
                                            'padding-bottom': '4px',
                                            'padding-left': '20px',
                                            'padding-right': '20px',
                                            'padding-top': '4px',
                                            width: 'auto',
                                        },
                                        target: '_blank',
                                        href: 'https://www.nutshell.com/crm-landing-pages',
                                    },
                                    computedStyle: {
                                        height: 34,
                                        hideContentOnMobile: false,
                                        width: 110,
                                    },
                                    style: {
                                        'padding-bottom': '8px',
                                        'padding-left': '8px',
                                        'padding-right': '8px',
                                        'padding-top': '8px',
                                        'text-align': 'center',
                                    },
                                },
                                locked: false,
                                type: 'mailup-bee-newsletter-modules-button',
                                uuid: 'ac5e3105-fd18-48f2-9d6a-2d627fceb8c9',
                            },
                        ],
                        style: {
                            'background-color': 'transparent',
                            'border-bottom': '0px solid transparent',
                            'border-left': '0px solid transparent',
                            'border-right': '0px solid transparent',
                            'border-top': '0px solid transparent',
                            'padding-bottom': '5px',
                            'padding-left': '0px',
                            'padding-right': '0px',
                            'padding-top': '5px',
                        },
                        uuid: 'bb40033f-6829-413b-bcfd-737759de2fac',
                    },
                ],
                container: {
                    style: {
                        'background-color': 'transparent',
                        'background-image': 'none',
                        'background-position': 'top left',
                        'background-repeat': 'no-repeat',
                    },
                },
                content: {
                    computedStyle: {
                        hideContentOnDesktop: false,
                        hideContentOnMobile: false,
                        rowColStackOnMobile: true,
                        rowReverseColStackOnMobile: false,
                        verticalAlign: 'top',
                    },
                    style: {
                        'background-color': 'transparent',
                        'background-image': 'none',
                        'background-position': 'top left',
                        'background-repeat': 'no-repeat',
                        'border-bottom': '0px solid transparent',
                        'border-left': '0px solid transparent',
                        'border-radius': '0px',
                        'border-right': '0px solid transparent',
                        'border-top': '0px solid transparent',
                        color: '#000000',
                        width: '600px',
                    },
                },
                empty: false,
                locked: false,
                synced: false,
                type: 'one-column-empty',
                uuid: '91887753-82cd-4750-9267-1b6a6efbc7a7',
            },
            {
                columns: [
                    {
                        'grid-columns': 12,
                        modules: [],
                        style: {
                            'background-color': 'transparent',
                            'border-bottom': '0px solid transparent',
                            'border-left': '0px solid transparent',
                            'border-right': '0px solid transparent',
                            'border-top': '0px solid transparent',
                            'padding-bottom': '5px',
                            'padding-left': '0px',
                            'padding-right': '0px',
                            'padding-top': '5px',
                        },
                        uuid: 'a94438c8-5014-43e5-8658-6d7bd6884bd9',
                    },
                ],
                container: {
                    style: {
                        'background-color': 'transparent',
                        'background-image': 'none',
                        'background-position': 'top left',
                        'background-repeat': 'no-repeat',
                    },
                },
                content: {
                    computedStyle: {
                        hideContentOnDesktop: false,
                        hideContentOnMobile: false,
                        rowColStackOnMobile: true,
                        rowReverseColStackOnMobile: false,
                        verticalAlign: 'top',
                    },
                    style: {
                        'background-color': 'transparent',
                        'background-image': 'none',
                        'background-position': 'top left',
                        'background-repeat': 'no-repeat',
                        'border-bottom': '0px solid transparent',
                        'border-left': '0px solid transparent',
                        'border-radius': '0px',
                        'border-right': '0px solid transparent',
                        'border-top': '0px solid transparent',
                        color: '#000000',
                        width: '600px',
                    },
                },
                empty: false,
                locked: false,
                synced: false,
                type: 'one-column-empty',
                uuid: '911e4ce8-c3ab-4ac7-b00f-016eae926690',
            },
            {
                columns: [
                    {
                        'grid-columns': 12,
                        modules: [
                            {
                                descriptor: {
                                    computedStyle: {
                                        class: 'center autowidth',
                                        hideContentOnMobile: false,
                                        width: '600px',
                                    },
                                    image: {
                                        alt: '',
                                        height: '200px',
                                        href: '',
                                        prefix: '',
                                        src: 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/3f2eeec5-d51f-4471-91a6-6c3e3bcdc67e/instance_4/1.png',
                                        target: '_blank',
                                        width: '667px',
                                    },
                                    style: {
                                        'padding-bottom': '0px',
                                        'padding-left': '0px',
                                        'padding-right': '0px',
                                        'padding-top': '4px',
                                        width: '100%',
                                    },
                                },
                                locked: false,
                                type: 'mailup-bee-newsletter-modules-image',
                                uuid: 'e1794bcf-2084-4c6f-99f8-0e2e00722573',
                            },
                            {
                                descriptor: {
                                    computedStyle: {hideContentOnMobile: false},
                                    spacer: {style: {height: '16px'}},
                                },
                                locked: false,
                                type: 'mailup-bee-newsletter-modules-spacer',
                                uuid: '42da9f8d-e329-47dc-8286-e51fffc32420',
                            },
                            {
                                descriptor: {
                                    computedStyle: {
                                        class: 'center autowidth',
                                        hideContentOnMobile: false,
                                        width: '600px',
                                    },
                                    image: {
                                        alt: '',
                                        height: '100px',
                                        href: '',
                                        prefix: '',
                                        src: 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/3f2eeec5-d51f-4471-91a6-6c3e3bcdc67e/instance_4/3.png',
                                        target: '_blank',
                                        width: '667px',
                                    },
                                    style: {
                                        'padding-bottom': '0px',
                                        'padding-left': '0px',
                                        'padding-right': '0px',
                                        'padding-top': '0px',
                                        width: '100%',
                                    },
                                },
                                locked: false,
                                type: 'mailup-bee-newsletter-modules-image',
                                uuid: 'e0a018a5-39b5-4fc1-bb2b-240c3d394950',
                            },
                            {
                                descriptor: {
                                    computedStyle: {hideContentOnMobile: false},
                                    spacer: {style: {height: '16px'}},
                                },
                                locked: false,
                                type: 'mailup-bee-newsletter-modules-spacer',
                                uuid: 'a5cc23a8-5ce7-4dd5-b35b-0d372be0be37',
                            },
                            {
                                descriptor: {
                                    computedStyle: {
                                        class: 'center autowidth',
                                        hideContentOnMobile: false,
                                        width: '600px',
                                    },
                                    image: {
                                        alt: '',
                                        height: '300px',
                                        href: '',
                                        prefix: '',
                                        src: 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/3f2eeec5-d51f-4471-91a6-6c3e3bcdc67e/instance_4/2.png',
                                        target: '_blank',
                                        width: '667px',
                                    },
                                    style: {
                                        'padding-bottom': '0px',
                                        'padding-left': '0px',
                                        'padding-right': '0px',
                                        'padding-top': '0px',
                                        width: '100%',
                                    },
                                },
                                locked: false,
                                type: 'mailup-bee-newsletter-modules-image',
                                uuid: '0819b162-4160-4117-9445-c1ad5f6d06e3',
                            },
                        ],
                        style: {
                            'background-color': 'transparent',
                            'border-bottom': '0px solid transparent',
                            'border-left': '0px solid transparent',
                            'border-right': '0px solid transparent',
                            'border-top': '0px solid transparent',
                            'padding-bottom': '5px',
                            'padding-left': '0px',
                            'padding-right': '0px',
                            'padding-top': '5px',
                        },
                        uuid: 'bb40033f-6829-413b-bcfd-737759de2fac',
                    },
                ],
                container: {
                    style: {
                        'background-color': 'transparent',
                        'background-image': 'none',
                        'background-position': 'top left',
                        'background-repeat': 'no-repeat',
                    },
                },
                content: {
                    computedStyle: {
                        hideContentOnDesktop: false,
                        hideContentOnMobile: false,
                        rowColStackOnMobile: true,
                        rowReverseColStackOnMobile: false,
                        verticalAlign: 'top',
                    },
                    style: {
                        'background-color': 'transparent',
                        'background-image': 'none',
                        'background-position': 'top left',
                        'background-repeat': 'no-repeat',
                        'border-bottom': '0px solid transparent',
                        'border-left': '0px solid transparent',
                        'border-radius': '0px',
                        'border-right': '0px solid transparent',
                        'border-top': '0px solid transparent',
                        color: '#000000',
                        width: '600px',
                    },
                },
                empty: false,
                locked: false,
                synced: false,
                type: 'one-column-empty',
                uuid: '7b8d1a9e-ac0f-49b3-8971-d4730dff0137',
            },
        ],
        template: {name: 'template-base', type: 'basic', version: '2.0.0'},
        title: '',
    },
});
